module.exports = __webpack_public_path__ + "static/media/jti_logo.5ef746bf.svg";